export enum RateType {
  Variable = "Variable",
  Fixed = "Fixed",
}

export enum ElecProductType {
  Standard = "Standard",
  Eco7 = "Eco7",
  TOU = "TOU",
}

export enum FuelType {
  Electricity = "Electricity",
  Gas = "Gas",
  DualFuel = "Dual Fuel",
}

export enum TariffType {
  Standard = "Standard",
  Green = "Green",
  EV = "EV",
}

export interface ElecRate {
  costPerKwhInPence: number
  name: string
  fromTime?: string
  toTime?: string
  eco7ElecConsumptionPerYearInKwh?: string
}

export interface RenewalQuoteRaw {
  costPerMonthInPounds: number
  costPerYearInPounds: number
  currentReferralFee?: number
  earlyExitFeePerFuelInPounds?: string
  elecConsumptionPerYearInKwh?: string
  elecMeterPointIdentifier?: string
  elecProductCode?: string
  elecProductType?: ElecProductType
  elecRates?: {
    costPerKwhInPence: string
    eco7ElecConsumptionPerYearInKwh?: string
    fromTime?: string
    name: string
    toTime?: string
  }[]
  elecStandingChargeInPence?: string
  fuelType: FuelType
  gasConsumptionPerYearInKwh?: string
  gasCostPerKwhInPence?: string
  gasMeterPointIdentifier?: string
  gasProductCode?: string
  gasStandingChargeInPence?: string
  mustSetUpHHReadingConsent?: boolean
  payment?: string
  quoteId: number
  rate: RateType
  renewalElecStartDate?: string
  renewalGasStartDate?: string
  shortTariffName: string
  tariffName: string
  tariffLengthInMonths?: number
  tariffType?: TariffType
  isRecommendedForRenewal: boolean
  elecAnnualCostInPounds?: number
  gasAnnualCostInPounds?: number
}
